import { QueryBuilderTokenType } from '../../../../../../../types';
import { ParseResultType, QueryExpressionParserType } from '../../../types';
import { parseBracketGroup, toConditionNode } from './helpers';

export const parsePrimary = (
  tokens: QueryBuilderTokenType[],
  index: number,
  parseExpression: QueryExpressionParserType
): ParseResultType | null => {
  const token = tokens[index];

  if (!token) {
    return null;
  }

  if (token.type === 'entityValue') {
    return {
      node: toConditionNode(token),
      nextIndex: index + 1,
    };
  }

  if (token.type === 'bracket' && token.bracket === 'OPEN') {
    return parseBracketGroup(tokens, index + 1, parseExpression);
  }

  return null;
};
